
<template>
	
	
	
</template>

<script>
	
	import ActionBar from "@/components/ActionBar.vue";
	import UsersDropdown from "@/components/Users/Dropdown.vue";
	
	export default {
		
		components: {},
		
		components: { ActionBar, UsersDropdown },
		
		computed: {
			
			actionButtons() {
				return [
					{
						name: "save",
						type: "success",
						icon: "el-icon-check",
						title: "Save Changes",
						disabled: !this.dirty,
					},
				];
			}
			
		},
		
		data() {
			return {
				dirty: false,
				settings: {},
			};
		},
		
		beforeRouteLeave(to, from, next) {
			if (this.dirty) {
				this.$confirm("There are unsaved changes on this page, are you sure you want to leave?", "Unsaved Changes", {
					confirmButtonText: "Leave",
					confirmButtonClass: "el-button--danger",
					cancelButtonText: "Cancel",
				}).then(() => {
					next();
				}).catch(() => {
					
				});
			} else {
				next();
			}
		}
		
	}
	
</script>

<style lang="css" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components/Base/Settings.vue